import { render, staticRenderFns } from "./ValidationFeedback.vue?vue&type=template&id=f32b7d9e&"
import script from "./ValidationFeedback.vue?vue&type=script&lang=js&"
export * from "./ValidationFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports